import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }
});
export const figure8b = {
    chart: {
        animation: false,
        marginTop: 50,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'line',
        height: '600px',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        style: {
            fontFamily: 'Montserrat'
        }
    },
    credits: {
        enabled: false
    },
    title: {
        text: null
    },
    subtitle: {
        text: null
    },
    
    exporting: {
        enabled: false
    },
    xAxis: [{
       
        categories: [
            {
                
                categories: ["2014", "", "2016", "", "2018", "", "2020", "2021",]
            },
            {
                name: "",
                categories: ['']
            },
            {
                name: "",
                categories: ['']
            },
            {
             
                categories: ["2014", "", "2016", "", "2018", "", "2020", "2021",]
            },
            {
                name: "",
                categories: ['']
            },
            {
                name: "",
                categories: ['']
            },
            {
               
                categories: ["2014", "", "2016", "", "2018", "", "2020", "2021",]
            },
            {
                name: "",
                categories: ['']
            },
            {
                name: "",
                categories: ['']
            },
            {
             
                categories: ["2014", "", "2016", "", "2018", "", "2020", "2021",]
            },
            {
                name: "",
                categories: ['']
            },
            {
                name: "",
                categories: ['']
            },
            {
               
                categories: ["2014", "", "2016", "", "2018", "", "2020", "2021",]
            },
            {
                name: "",
                categories: ['']
            },
            {
                name: "",
                categories: ['']
            },
            
        ],
        tickLength: 0,
        labels: {
            align: 'center',
            rotation: 270,
            tickLength: 15,

        },
        lineWidth: 0,
        fontsize: '2px',
        tickWidth: 0
    },
    ],
    labels: {
        //     reserveSpace: true,
        //     groupedOptions: [
        //         {
        //             rotation: 0,
        //             style: {transform: 'unset', 'transform-origin': '74% 12px', 'padding-right': '16px'},
        //         }
        //         ],
        //   rotation: -90,
        //     useHTML: true,
        //     style: {
        //         transform: 'rotate(-90deg)',
        //         'transform-origin': '50% 11px',
        //         width: 'unset',
        //         'padding-right': '42px',
        //         overflow: 'visible'
        //     },
    },

    yAxis: [{
        labels: {
            style: {
                fontWeight: 'normal',
                color: '#999999',
                fontSize: '12px'
            },
        },
	format: '{value}%',
	    gridLineWidth: 2,
        floor: 0,
        ceiling: 70,
	tickInterval: 10,
	    title: {
            text: '',
            style: {
                color: Highcharts.getOptions().colors[1]
            }
        }
    }],
    tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        valueSuffix: '%',
        style: {
            padding: 0
        }
    },
    legend: {
        enabled: false,
    },
    series: [{
        name: 'Hommes - modérée ou grave',
        color: '#002060',
        data: [20.0, 20.0, 21.9, 23.3, 25.2, 25.7, 28.5, 27.6, null, null,
            44.9, 46.0, 51.3, 54.7, 53.8, 53.4, 56.7, 60.3, null, null,
            17.5, 17.2, 18.5, 19.5, 22.6, 23.2, 25.8, 23.7, null, null,
            23.0, 22.9, 24.9, 28.7, 28.7, 29.2, 34.2, 33.9, null, null,
            9.2, 9.4, 10.3, 10.0, 10.0, 10.8, 11.8, 11.1, null, null,

        ]
    },
    {
        name: 'Hommes - grave',
        color: '#0070c0',
        data: [
            7.6, 7.3, 8.3, 9.1, 9.7, 10.2, 11.5, 11.6, null, null,
            19.4, 18.8, 22.4, 25.6, 23.1, 23.4, 25.4, 29.0, null, null,
            6.7, 6.4, 6.7, 7.2, 8.7, 9.1, 10.3, 9.7, null, null,
            7.7, 7.0, 8.6, 10.3, 10.2, 10.8, 12.4, 12.3, null, null,
            2.2, 2.3, 3.1, 2.5, 2.6, 3.0, 3.6, 3.1, null, null,]
        },
        {
            name: 'Femmes - modérée ou grave',
            color: '#833c0b',
            data: [
                22.3, 22.0, 23.5, 25.3, 26.2, 27.5, 31.5, 31.9, null, null,
                49.2, 47.8, 54.1, 57.1, 55.0, 56.5, 59.0, 61.3, null, null,
                19.2, 18.8, 19.3, 20.9, 22.9, 24.1, 28.5, 28.1, null, null,
                27.0, 26.8, 29.2, 34.2, 33.9, 35.6, 43.6, 45.2, null, null,
                11.8, 12.0, 12.1, 11.6, 11.3, 12.0, 13.4, 14.2, null, null,]
        },
        {
            name: 'Femmes - grave',
            color: '#c00000',
            data: [
                8.5, 8.1, 8.9, 9.4, 10.4, 11.1, 12.8, 14.1, null, null,
                21.7, 19.6, 23.5, 25.6, 24.5, 25.0, 27.0, 30.0, null, null,
                7.4, 7.1, 7.2, 7.4, 9.2, 10.0, 11.9, 13.1, null, null,
                9.6, 8.9, 10.4, 12.5, 12.4, 13.2, 14.8, 16.5, null, null,
                2.3, 2.7, 2.9, 2.7, 2.7, 3.0, 3.5, 3.3, null, null,]
        },


    ]
}
